import React, { useState } from 'react'

import {
  useHeadlineMetric,
  useMetric,
  useMetricsFetched
} from 'redux/hooks/Metrics'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

import MetricView from 'components_new/organisms/MetricView'
import MetricViewDialog from 'components_new/organisms/dialogs/MetricViewDialog'
import MetricPreview, {
  METRIC_PREVIEW_HEIGHT
} from 'components_new/organisms/MetricPreview'

/**
 * The metric the results page leads with — driftnetto, the single economic
 * headline of a real-estate company.
 *
 * Which metric that is, the settings it is read at and whether this customer
 * has it at all come from GET /v1/kpis/headline. Until that answers the
 * section holds its place as a skeleton; a customer with no headline gets no
 * section at all, and no placeholder.
 */
const HeadlineMetricPreview = () => {
  const { metric: headline, resolved } = useHeadlineMetric()
  const metricsFetched = useMetricsFetched()

  const metric = useMetric(
    headline?.id,
    headline?.settings.variant_kpi_template_id
  )

  const [dialog, setDialog] = useState<boolean>(false)

  if (!resolved || (headline && !metric && !metricsFetched)) {
    return <Skeleton height={METRIC_PREVIEW_HEIGHT} variant="rounded" />
  }

  if (!headline || !metric) {
    return null
  }

  return (
    <>
      {1 === 1 ? (
        <Box sx={{ height: 400 }}>
          <MetricView
            chart="line"
            clickOptions={{
              explore: true
            }}
            id={headline.id}
            queryParams={{}}
            setQueryParams={() => {}}
            settings={headline.settings}
            TitleProps={{
              link: true
            }}
          />
        </Box>
      ) : (
        <MetricPreview
          id={headline.id}
          onView={() => setDialog(true)}
          settings={headline.settings}
        />
      )}

      {/*-- dialogs --*/}
      <MetricViewDialog
        metric={headline}
        onClose={() => setDialog(false)}
        open={dialog}
      />
    </>
  )
}

export default HeadlineMetricPreview
